/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationVisualReferenceRect } from './HomeHealthCertificationVisualReferenceRect';
import {
    HomeHealthCertificationVisualReferenceRectFromJSON,
    HomeHealthCertificationVisualReferenceRectFromJSONTyped,
    HomeHealthCertificationVisualReferenceRectToJSON,
    HomeHealthCertificationVisualReferenceRectToJSONTyped,
} from './HomeHealthCertificationVisualReferenceRect';

/**
 * 
 * @export
 * @interface HomeHealthCertificationVisualReference
 */
export interface HomeHealthCertificationVisualReference {
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationVisualReference
     */
    document_id: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationVisualReference
     */
    document_name: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationVisualReference
     */
    page_num: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationVisualReference
     */
    text: string;
    /**
     * 
     * @type {HomeHealthCertificationVisualReferenceRect}
     * @memberof HomeHealthCertificationVisualReference
     */
    rect: HomeHealthCertificationVisualReferenceRect;
}

/**
 * Check if a given object implements the HomeHealthCertificationVisualReference interface.
 */
export function instanceOfHomeHealthCertificationVisualReference(value: object): value is HomeHealthCertificationVisualReference {
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('document_name' in value) || value['document_name'] === undefined) return false;
    if (!('page_num' in value) || value['page_num'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('rect' in value) || value['rect'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationVisualReferenceFromJSON(json: any): HomeHealthCertificationVisualReference {
    return HomeHealthCertificationVisualReferenceFromJSONTyped(json, false);
}

export function HomeHealthCertificationVisualReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationVisualReference {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'],
        'document_name': json['document_name'],
        'page_num': json['page_num'],
        'text': json['text'],
        'rect': HomeHealthCertificationVisualReferenceRectFromJSON(json['rect']),
    };
}

export function HomeHealthCertificationVisualReferenceToJSON(json: any): HomeHealthCertificationVisualReference {
    return HomeHealthCertificationVisualReferenceToJSONTyped(json, false);
}

export function HomeHealthCertificationVisualReferenceToJSONTyped(value?: HomeHealthCertificationVisualReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
        'document_name': value['document_name'],
        'page_num': value['page_num'],
        'text': value['text'],
        'rect': HomeHealthCertificationVisualReferenceRectToJSON(value['rect']),
    };
}

